export default __webpack_public_path__ + "static/media/success-vehicle.0b905768.png";